import * as vp from 'vopay';
import { FunctionComponent, memo, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './CrossRiver.module.scss';
import iFrameStyles from './CrossRiverIFrame.module.scss';
import { useToken } from '../../../../providers/Token.provider';
import { useDataFetchIndicator } from '../../../../hooks';
import BrandingLogo from '../../../UI/BrandingLogo/BrandingLogo';

const { Box, Title } = vp;

type CrossRiverProps = {
  iFrameUrl: string;
};

type FC = FunctionComponent<CrossRiverProps>;

export const CrossRiverP2C: FC = memo((props: CrossRiverProps) => {
  const { iFrameUrl } = props;
  const { t } = useTranslation('translations', { keyPrefix: 'DebitCardForm' });
  const [iframeLoaded, setIframeLoaded] = useState<boolean>(false);
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const iFrameRef = useRef<HTMLIFrameElement | null>(null);
  const { token } = useToken();
  const buttonColor = vp.chooseColor<string | null | undefined>(
    '#FFD147',
    token?.BrandingDetails?.Branding?.PrimaryColor,
  );
  const dynamicButton = `.post-cards .btn,.post-cards .btn:active,.post-cards .btn:focus{background:${buttonColor}!important}`;
  useEffect(() => {
    setDataFetchingInfo(true, 'Loading', 'fullScreen');
    if (iframeLoaded) {
      setTimeout(() => {
        iFrameRef.current?.contentWindow?.postMessage(
          JSON.stringify({
            event: 'cssContent',
            data: `${iFrameStyles}${dynamicButton}`,
          }),
          new URL(iFrameUrl).origin,
        );
        setTimeout(() => {
          setDataFetchingInfo(false);
          if (iFrameRef.current) iFrameRef.current.style.opacity = '1';
        }, 1000);
      }, 1000);
    }
  }, [iframeLoaded]);

  const handleIframeLoad = () => {
    setIframeLoaded(true);
  };

  return (
    <>
      <div className={styles.container}>
        <Box flx="col" width="50%">
          {token?.BrandingDetails?.Logo && (
            <Box pb="lg" jc="center">
              <BrandingLogo src={token?.BrandingDetails?.Logo} />
            </Box>
          )}
          <Box mb="md" flx="col" height="auto">
            <Title title={`${t('title')}`} size="lg" bold />
          </Box>
          <iframe
            id="myIframe"
            name="crossriver"
            title="Cross River OCT"
            className={styles.crossRiverIFrame}
            key={iFrameUrl}
            src={iFrameUrl}
            ref={iFrameRef}
            style={{ opacity: 0 }}
            onLoad={handleIframeLoad}
          />
        </Box>
      </div>
    </>
  );
});
